// UseEffect is a hook that is used to get time from DJango and the backendvector-icons/
import React from 'react';
import { SafeAreaView, StyleSheet, useWindowDimensions, Text, View } from 'react-native';
import MyLeavesDetailsScreen from './MyLeavesDetailsScreen';
import { useTheme } from 'react-native-paper';

const MyLeaves = (props) => {
  const { width, height } = useWindowDimensions();
  const { colors } = useTheme()
  const styles = makeStyles(colors)
  return (
    <SafeAreaView style={[styles.main]}>
      <MyLeavesDetailsScreen
        selectNewLeaveScreen={props.selectNewLeaveScreen} />
      
    </SafeAreaView>
  )
};

const makeStyles = (colors) => StyleSheet.create({
  main: {
    flex: 1,
  },
});

export default MyLeaves;